export default __webpack_public_path__ + "static/coffee-62fb3d5e1d67343c2e0d9fadcea49fca.svg";